import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "Overview",
    p: [
      "Trainova Fitness (\"Trainova\", \"we\", \"us\") is committed to protecting your privacy. This policy explains what information we collect, how we use it, and the choices you have when you use our website, join our waitlist, or contact us.",
      "By using Trainova, you agree to the collection and use of information in accordance with this policy.",
    ],
  },
  {
    h: "Information We Collect",
    p: ["We collect information you provide directly to us, including:"],
    list: [
      "Waitlist details: your name, email address, and selected fitness goal.",
      "Contact details: your first and last name, phone number, email, and message content.",
      "Profile information (within the app): fitness goals, workout preferences, photos, matches and messages.",
      "Technical data: basic usage and device information collected automatically to keep the service secure and reliable.",
    ],
  },
  {
    h: "How We Use Your Information",
    p: ["We use the information we collect to:"],
    list: [
      "Operate the waitlist and notify you about early access and launch updates.",
      "Match you with suitable gym partners based on your goals and preferences.",
      "Respond to your questions and provide customer support.",
      "Improve, personalize and secure the Trainova experience.",
    ],
  },
  {
    h: "Sharing of Information",
    p: [
      "We do not sell your personal information. We only share data with trusted service providers who help us operate Trainova (for example, hosting and database providers), and only as needed to deliver the service. We may also disclose information where required by law.",
    ],
  },
  {
    h: "Data Retention & Deletion",
    p: [
      "We retain your information for as long as your account or waitlist entry is active, or as needed to provide the service. You can request deletion at any time.",
      "Deleting your Trainova account permanently removes your profile, photos, matches, messages, workout preferences and associated personal information. To delete your account, use Side Bar > Settings > Delete Account in the app, or email support@trainovaapp.com.",
    ],
  },
  {
    h: "Your Rights",
    p: [
      "Depending on your location, you may have the right to access, correct, export or delete your personal data, and to object to certain processing. To exercise these rights, contact us at support@trainovaapp.com.",
    ],
  },
  {
    h: "Security",
    p: [
      "We use reasonable technical and organizational measures to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    h: "Changes to This Policy",
    p: [
      "We may update this Privacy Policy from time to time. Material changes will be reflected by updating the date at the top of this page.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      eyebrow="YOUR DATA, PROTECTED"
      title="Privacy"
      accent="policy"
      subtitle="How Trainova collects, uses and protects your personal information."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
